import { BILinkModel } from '@app/domain/interfaces/bi/BILinkModel';
import { ApiServiceBase, IApiServiceBase } from './apiServiceBase';

export default interface IBIService extends IApiServiceBase<BILinkModel, BILinkModel> {
  updateLink(id: number, url: string): Promise<boolean>;
}

export class BIService extends ApiServiceBase<BILinkModel, BILinkModel> implements IBIService {
  constructor() {
    super('admin/bilink');
  }

  async updateLink(id: number, url: string): Promise<boolean> {
    const { data } = await this.api.post(`${id}`, {
      url,
    });

    return data;
  }
}
